import { SIDEBAR_SECTIONS } from '../constants';
import { ISidebarSection } from '../../Sidebar.types';

export class SidebarHelper {
  private static sections = [...SIDEBAR_SECTIONS];

  public static injectItemsBySlug(slug: string, items: ISidebarSection[]) {
    for (const section of this.sections) {
      if (section.slug !== slug || !section.subItems) {
        continue;
      }

      section.subItems = [...items];

      break;
    }

    return this.sections;
  }

  public static extractSectionNameFromPath(path: string) {
    const splitted = path.split('/');

    const prePath = splitted[splitted.length - 2];
    const lastPath = splitted.pop();

    const pathname = prePath ? +`/${prePath}/${lastPath}` : `/${lastPath}`;

    return pathname;
  }

  public static getSections() {
    return this.sections;
  }
}
